import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/auth/googleSignIn';
import { BASE_API_URL } from '../../../config';
import { applyCellRouting } from '../../../cellRouting';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  try {
    const { credential } = action.payload;
    // Sign in against the BAKED login/router endpoint: at this point we don't
    // yet know the user's cell. A `wrong_cell` 409 is followed transparently
    // by the cellRouting axios interceptor; the response carries `cell` +
    // `api_base_url`, which we persist so all subsequent calls route to the
    // user's own cell (same contract as verify-magic-link).
    const response = yield call(axios.post,
      `${BASE_API_URL}/user/google-signin`,
      { credential },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    // Tolerate both the raw shape and the ``data`` envelope (responseJSON).
    const payload = response.data?.data ?? response.data ?? {};
    const { token: jwtToken, user, cell, api_base_url: apiBaseUrl } = payload;

    // Store JWT token in localStorage
    localStorage.setItem('authToken', jwtToken);
    localStorage.setItem('user', JSON.stringify(user));

    // Persist the user's cell routing (cell -> api_base_url) before anything
    // else fires API calls.
    yield call(applyCellRouting, { token: jwtToken, cell, apiBaseUrl });

    yield put(fetchSuccess(response.data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
